import { announcementList, featuredAnnouncement } from "@/mocks/chigua";
import SectionHead from "./SectionHead";
import Reveal from "@/components/feature/Reveal";
import { toneChip } from "./tone";

export default function Announcements() {
  return (
    <section id="announcements" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <SectionHead
            kicker="公告中心 · ANNOUNCEMENTS"
            title="最新官方公告"
            subtitle="重点公告、功能更新与例行通知在此集中呈现,第一时间掌握吃瓜官网正式发布内容。"
            more="查看全部公告"
            moreHref="#announcements"
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-5">
          {/* 重点公告大卡 */}
          <Reveal className="lg:col-span-3">
            <article className="group relative h-full overflow-hidden rounded-2xl border border-background-200/70 bg-background-100">
              <div className="relative h-52 overflow-hidden md:h-64">
                <img
                  src="https://readdy.ai/api/search-image?query=vibrant%20editorial%203D%20illustration%20of%20an%20official%20announcement%20scroll%20with%20a%20glowing%20red%20wax%20seal%20and%20floating%20legal%20documents%2C%20small%20megaphone%20and%20checkmark%20shapes%2C%20warm%20cream%20vermilion%20and%20watermelon%20green%20palette%2C%20soft%20pastel%20gradient%20background%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark&width=1200&height=720&seq=featured-announcement-2026&orientation=landscape"
                  alt="吃瓜官网重点公告封面"
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/55 via-transparent to-transparent"></div>
                <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-flag-2-fill text-sm"></i>
                  {featuredAnnouncement.tag}
                </span>
                <span className="absolute bottom-4 right-4 inline-flex items-center gap-1.5 rounded-full bg-background-950/50 px-3 py-1 text-xs text-background-100 backdrop-blur">
                  <i className="ri-time-line"></i>
                  {featuredAnnouncement.time} · {featuredAnnouncement.date}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-2xl">
                  {featuredAnnouncement.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  {featuredAnnouncement.summary}
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {featuredAnnouncement.highlights.map((h) => (
                    <span key={h} className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                      <i className="ri-check-line"></i>
                      {h}
                    </span>
                  ))}
                </div>
                <div className="mt-5 flex items-center justify-between border-t border-background-200/70 pt-4">
                  <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-book-read-line"></i>
                    {featuredAnnouncement.readTime}
                  </span>
                  <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
                    查看详情
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                  </span>
                </div>
              </div>
            </article>
          </Reveal>

          {/* 公告列表 */}
          <Reveal className="lg:col-span-2" delay={80}>
            <div className="flex h-full flex-col gap-3 rounded-2xl border border-background-200/70 bg-background-50 p-2.5 md:p-3">
              {announcementList.map((item) => (
                <a
                  key={item.id}
                  href="#announcements"
                  className="group flex flex-col gap-2 rounded-xl border border-transparent bg-background-100/70 p-3.5 transition-all hover:-translate-y-0.5 hover:border-secondary-200 hover:bg-background-100"
                >
                  <div className="flex items-center justify-between gap-2">
                    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${toneChip[item.type as keyof typeof toneChip]}`}>
                      {item.tag}
                    </span>
                    <span className="font-label text-xs text-foreground-400">{item.date}</span>
                  </div>
                  <p className="text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </p>
                </a>
              ))}
              <a
                href="#announcements"
                className="mt-auto inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-dashed border-background-300 py-3 text-sm font-medium text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                前往公告归档检索
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}